import React from 'react'
import { Roles } from '../../../constants/Roles'
import Storage from '../../../services/Storage'
import './index.css'

export const NumberCardBlock = ({ heading, ftdCount, mtdCount, onclickChildFtd, onclickChildMtd, ftdNumberColor, mtdumberColor, handleParentClick }) => {
    
    let userInfo = Storage.getUserInfoDetail();
    let roleName = userInfo ? userInfo.role: '';

    return (
        <div id='numberCardBlock' className={roleName !== Roles.TM_NAME ? 'dashboardTitleArrow' : ''} onClick={roleName !== Roles.TM_NAME ? handleParentClick : undefined} style={{cursor: roleName !== Roles.TM_NAME ? 'pointer' : 'auto'}}>
            <h6>{heading}</h6>
            <div id='numberCardBlockInner'>
                <div className="innerCardText">
                    <span className="innerCardTextTitle">FTD</span>
                    <span onClick={onclickChildFtd} className={`number ${ftdNumberColor}`}>{ftdCount}</span>
                </div>
            </div>
            <div id='numberCardBlockInner'>
                <div className="innerCardText">
                    <span className="innerCardTextTitle">MTD</span>
                    <span onClick={onclickChildMtd} className={`number ${mtdumberColor}`}>{mtdCount}</span>
                </div>
            </div>
        </div>
    )
}